import type { BackgroundColors, GridSeperatorSizes } from './LayoutTypes';

export const getBackgroundColorClassName = (value?: BackgroundColors) => {
    switch (value) {
        case 'cotton':
            return 'sgw-layout--bg__cotton';
        default:
            return '';
    }
};

export const getGridSeperatorSizeClassName = (value?: GridSeperatorSizes) => {
    switch (value) {
        case 'small':
            return 'sgw-layout--grid-seperator-small';
        case 'large':
            return 'sgw-layout-grid-seperator-large';
        default:
            return '';
    }
};
